import { createEvent } from 'effector';
import { type ShowChecksProps } from './ShowChecks';
import { openShowChecksModal } from './lib';

export const showChecks = createEvent<ShowChecksProps>();

showChecks.watch(openShowChecksModal);
